import { create } from 'zustand';
import dayjs from 'dayjs';
import { DateRangeShortcutsItem } from '@libs/models/common';
import { dateRangeShortcuts } from '@libs/models/shifts';
import { StaffListItem } from '@libs/models/talents';
import { getTalents } from '@libs/api/talents';
import { createDefaultFilterSlice, DefaultFilterState } from '../defaultFilterSlice';

import { persist } from 'zustand/middleware';

type ShiftFilterState = {
  dateRangeShortcuts: DateRangeShortcutsItem[];
  loading: boolean;
  filterProviders: StaffListItem[];
  loadData: (options: { locationId: string }) => Promise<void>;
  loadProvidersFiltersData: (options: { locationId?: string; searchTerm?: string }) => Promise<void>;
};

export const useShiftsFilter = create<DefaultFilterState & ShiftFilterState>()(
  persist(
    (set, get, ...a) => ({
      ...createDefaultFilterSlice(set, get, ...a),
      dateRangeShortcuts: dateRangeShortcuts,
      loading: false,
      filterProviders: [],

      loadData: async ({ locationId }) => {
        set({
          loading: true,
        });
        try {
          const data = await getTalents({
            page: 1,
            size: 50,
            filters: {
              locations: {
                key: 'locations',
                value: [locationId],
              },
            },
          });
          set({
            filterProviders: data.items,
            loading: false,
          });
        } catch (error) {
          set({
            loading: false,
          });
          throw error;
        }
      },
      loadProvidersFiltersData: async ({ locationId, searchTerm = '' }) => {
        set({
          loading: true,
        });
        try {
          const talentsData = await getTalents({
            page: 1,
            size: 50,
            filters: locationId
              ? {
                  locations: {
                    key: 'locations',
                    value: [locationId],
                  },
                }
              : {},
            search: searchTerm,
          });

          set({
            filterProviders: talentsData.items,
            loading: false,
          });
        } catch (error) {
          set({
            loading: false,
          });
          throw error;
        }
      },
    }),

    {
      name: 'userdata:shiftsList',
      partialize: (state) =>
        Object.keys(state)
          .filter((key) => !['loading', 'filterProviders', 'dateRangeShortcuts'].includes(key))
          .reduce((acc, key) => ({ ...acc, [key]: (state as any)[key] }), {}),
    },
  ),
);
